import React from "react"

export function ErrorMessage() {
  return <div style={{ width: "100%", "text-align": "center", padding: "30px" }}>
    <div>
      Si è verificato un errore imprevisto. Contattare il supporto tecnico.
    </div>
  </div>
}